import { get, post, remove } from "@/utils/request";
import apiMap from "@/config";

const riskApi = apiMap.riskApi

export const getRiskTagList = data => 
  get(`${riskApi}/risk/tag/list`, data);

export const getRiskTagUpdate = data =>
  post(`${riskApi}/risk/tag/update`, data);

export const getRiskTagAdd = data =>
  post(`${riskApi}/risk/tag/add`, data);
